export const MarkerType = {
  None: 'none',
  Bounds: 'bounds',
  Platform: 'platform'
} as const;
export type MarkerTypeKeys = keyof typeof MarkerType;
export type MarkerTypeValues = typeof MarkerType[MarkerTypeKeys];

export default class EditorMarker {
  public scene: Phaser.Scene;
  public name: string;
  public markerType: MarkerTypeValues;
  public x: number;
  public y: number;
  public scaleX: number;
  public scaleY: number;

  constructor(scene: Phaser.Scene, x: number = 0, y: number = 0, texture?: string, frame?: number | string) {
    this.scene = scene;
    this.name = 'Editor Entity';
    this.markerType = MarkerType.None;
    this.x = x;
    this.y = y;
    this.scaleX = 1;
    this.scaleY = 1;
  }
}
